module.exports = __webpack_public_path__ + "img/res360_logo.7805ec92.png";